import { render } from "./caseSearch.vue?vue&type=template&id=56d9f8d0"
import script from "./caseSearch.vue?vue&type=script&lang=js"
export * from "./caseSearch.vue?vue&type=script&lang=js"

import "./caseSearch.vue?vue&type=style&index=0&id=56d9f8d0&lang=scss"

import exportComponent from "F:\\webStorm workspace\\ujk_tangying\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__